import type { Example } from '../types';

export const motionAnimationExample: Example = {
  id: 'motion-animation',
  title: 'Preview Motion & Animation',
  categoryId: 'viewer',
  description: 'motion() — spin, orbit, translation without recompiling',
  scadCode: `/* Preview Motion & Animation */

// markdown:tip
// **Preview Motion** — Wrap any geometry with \`motion()\` to animate it
// in the viewer without recompiling. The **Pause** button appears in the
// toolbar automatically. Try adjusting speeds and orbit distance below.

/* [Planet] */

// Planet radius
planet_r = 22; // [10:1:40]

// Spin speed (deg/s)
planet_spin = 30; // [0:1:120]

// Planet color
// color
planet_color = [0.25, 0.5, 0.85];

/* [Moon] */

// Moon radius
moon_r = 7; // [3:0.5:15]

// Orbit radius
orbit_r = 55; // [30:1:100]

// Orbit speed (deg/s)
orbit_speed = 45; // [5:1:120]

// Moon color
// color
moon_color = [0.75, 0.72, 0.65];

/* [Ring] */

// Show ring?
show_ring = true;

// Ring tilt (degrees)
ring_tilt = 22; // [0:1:60] {show_ring == true}

// Ring color
// color
ring_color = [0.85, 0.75, 0.4, 0.6];

// --- parameters end ---

// Planet — spins in place
color(planet_color)
motion(spin=[0, 0, planet_spin])
  sphere(r=planet_r, $fn=64);

// Ring — tilted, rotates with planet
if (show_ring) {
  color(ring_color)
  motion(spin=[0, 0, planet_spin])
  rotate([ring_tilt, 0, 0])
  difference() {
    cylinder(r=planet_r * 1.9, h=3, center=true, $fn=80);
    cylinder(r=planet_r * 1.3, h=4, center=true, $fn=80);
  }
}

// Moon — orbits the planet
color(moon_color)
motion(revolution=[0, 0, orbit_speed], orbit_radius=orbit_r)
  sphere(r=moon_r, $fn=32);

// Ambient fill
light_directional(color=[0.9, 0.9, 1.0], position=[100, 60, 120], intensity=0.7);
light_directional(color=[0.3, 0.4, 0.8], position=[-80, -40, 40], intensity=0.25);
`,
};
